import {createAction} from 'Shared/utilities/actionCreator';

export const PAGE_ID = {
  '/login': `login`,
  '/agent/agentDashboard': `agentDashboard`,
  '/agent/policies': `agentPolicies`,
  '/agent/accounts': `agentAccount`,
  '/agent/commissions': `commisions`,
  '/agent/policies/correspondence': `agentCorrespondence`,
  '/users/ssoAccounts': `singleSignOnHeader`,
  '/agent/agentInformation/news': `agentNews`,
  '/users/profile': `userProfile`,
  agentPoliciesDetails: `agentPoliciesDetails`,
  agentAccountViewDetails: `agentAccountViewDetails`,
  agentPoliciesUploadDocument: `agentPoliciesUploadDocument`,
  agentPoliciesViewClaims: `agentPoliciesViewClaims`,
};

export type DigitalDataPageType = {
  pageId?: string;
};

export type CtaResponseType = {
  eventAction?: string;
};

export type DigitalDataDto = {
  page?: DigitalDataPageType;
  ctaResponse?: CtaResponseType;
};

export enum AnalyticsActionType {
  GET_ANALYTICS_STATE = 'analytics/GET_ANALYTICS_STATE',
  CHANGE_ANALYTICS_STATE = 'analytics/CHANGE_ANALYTICS_STATE',
}

export const DEFAULT_STATE: AnalyticsState = {
  analytics: {},
};

export const getAnalyticsState = (params: DigitalDataDto) =>
  createAction(AnalyticsActionType.GET_ANALYTICS_STATE, {
    params,
  });

export const changeAnalyticsState = (digitalData: DigitalDataDto) =>
  createAction(AnalyticsActionType.CHANGE_ANALYTICS_STATE, {
    digitalData,
  });

type AnalyticsState = {
  analytics: DigitalDataDto;
};

type AnalyticsActions = ReturnType<typeof getAnalyticsState> | ReturnType<typeof changeAnalyticsState>;

export default (state: AnalyticsState = DEFAULT_STATE, action: AnalyticsActions): AnalyticsState => {
  switch (action.type) {
    case AnalyticsActionType.CHANGE_ANALYTICS_STATE:
      return {
        ...state,
        analytics: action.payload.digitalData,
      };
    case AnalyticsActionType.GET_ANALYTICS_STATE:
      return {
        ...state,
      };
    default:
      return state;
  }
};
